import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../../../__styling'
import { tokens } from '@news-mono/design-tokens'
import { IconSpinner } from '../../../../icons'

const { neutral } = tokens.thenightly.colors.palette

export const StyledLayout = styled.div({
    display: 'flex',
    flexDirection: 'column',
    padding: calcRem(0),
    gap: calcRem(24),

    [breakpoint('sm')]: {
        padding: calcRem(12, 32),
        gap: calcRem(32),
    },

    [breakpoint('xs')]: {
        flexDirection: 'row',
    },
})

export const StyledColumnA = styled.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,

    gap: calcRem(8),
})

export const StyledColumnB = styled.div({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,

    gap: calcRem(8),
})

export const StyledBodyText = styled.p({
    margin: 0,
    textAlign: 'left',
})

export const StyledForm = styled.form({
    display: 'flex',
    gap: calcRem(16),
    flexDirection: 'column',
    alignItems: 'flex-start',
})

export const StyledInputWrapper = styled.div({
    padding: calcRem(8, 16),
    backgroundColor: neutral[10],
    border: `1px solid ${neutral[20]}`,
    borderRadius: calcRem(8),
    fontSize: calcRem(14),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: neutral[70],
    width: '100%',

    focus: {
        outline: `2px solid ${neutral[30]}`,
    },
})

export const StyledInput = styled.input<{ hasError: boolean }>(
    ({ hasError }) => ({
        marginRight: '0',
        padding: calcRem(4, 0),
        height: '100%',
        border: 'none',
        borderRadius: '0',
        fontSize: calcRem(16),
        backgroundColor: 'inherit',
        lineHeight: calcRem(24),
        color: neutral[70],
        width: '100%',

        focus: {
            outline: 'none',
        },

        '&::placeholder': {
            color: hasError
                ? tokens.thenightly.colors.palette.utility.error.default
                : 'default',
        },
        '&:focus': {
            outline: 'none',
        },
    }),
)

export const StyledButtonWrapper = styled.div({
    width: '100%',
    '&.button': {
        width: '100%',
    },
})

export const StyledSpinner = styled(IconSpinner)({
    width: '7%',
    alignSelf: 'center',
})

export const StyledValidationError = styled.div(({ theme }) => ({
    color: tokens.thenightly.colors.palette.utility.error.light,
    font: theme.fonts.sansSerif,
    fontSize: calcRem(12),
    fontWeight: 400,
    lineHeight: calcRem(16),
    paddingLeft: calcRem(16),
    marginTop: calcRem(-11),
}))
